<div class="tpl3pl-page-container">
	<div class="tpl3pl-toolbar">
		<div class="tpl3pl-toolbar-filters"></div>
		<div class="tpl3pl-toolbar-actions">
			<button mat-stroked-button (click)="openRawRequestResponse()" [disabled]="rawLoading" matTooltip="View raw request/response from 3PL API">
				<mat-spinner *ngIf="rawLoading" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!rawLoading">visibility</mat-icon> View raw request / response
			</button>
			<button mat-raised-button color="primary" (click)="loadOpenOrders()" [disabled]="loading">
				<mat-icon>refresh</mat-icon> Refresh
			</button>
		</div>
	</div>

	<div *ngIf="errorMessage" class="alert alert-warning mb-3">{{ errorMessage }}</div>

	<div class="table-responsive position-relative tpl3pl-table-wrapper">
		<div *ngIf="loading" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="mt-2 mb-0">Loading…</p>
		</div>
		<table mat-table [dataSource]="dataSource" class="w-100" matSort [class.tpl3pl-loading-opacity]="loading">
			<ng-container matColumnDef="pgs_orderno">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>PGS Order ID</th>
				<td mat-cell *matCellDef="let item">{{ item.pgS_OrderNo ?? item.pgs_orderno ?? item.PgsOrderNo ?? '-' }}</td>
			</ng-container>
			<ng-container matColumnDef="status">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
				<td mat-cell *matCellDef="let item">
					<span class="badge" [ngClass]="getStatusBadgeClass(item)">{{ item.status ?? item.Status ?? item.OrderStatus ?? '-' }}</span>
				</td>
			</ng-container>
			<ng-container matColumnDef="so">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>SO</th>
				<td mat-cell *matCellDef="let item">{{ item.so ?? '-' }}</td>
			</ng-container>
			<ng-container matColumnDef="po">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>PO</th>
				<td mat-cell *matCellDef="let item">{{ item.po ?? '-' }}</td>
			</ng-container>
			<ng-container matColumnDef="consignee">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Consignee</th>
				<td mat-cell *matCellDef="let item" class="consignee-cell">{{ item.consignee ?? '-' }}</td>
			</ng-container>
			<ng-container matColumnDef="destination">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Destination</th>
				<td mat-cell *matCellDef="let item" class="destination-cell" [matTooltip]="(item.destination ?? '') || '–'">{{ item.destination ?? '-' }}</td>
			</ng-container>
			<ng-container matColumnDef="warehouse">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Warehouse</th>
				<td mat-cell *matCellDef="let item" class="warehouse-cell">{{ item.warehouse ?? '-' }}</td>
			</ng-container>
			<ng-container matColumnDef="createddate">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
				<td mat-cell *matCellDef="let item">{{ formatDate(item.createdDate ?? item.createddate ?? item.CreatedDate) }}</td>
			</ng-container>
			<ng-container matColumnDef="RoutedDate">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Routed</th>
				<td mat-cell *matCellDef="let item">{{ formatDate(item.routedDate ?? item.RoutedDate) }}</td>
			</ng-container>
			<ng-container matColumnDef="ScheduledPickUpDate">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Scheduled Pickup</th>
				<td mat-cell *matCellDef="let item">{{ formatDate(item.scheduledPickUpDate ?? item.ScheduledPickUpDate) }}</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr
				mat-row
				*matRowDef="let row; columns: displayedColumns"
				class="tpl3pl-open-orders-row"
				[class.tpl3pl-open-orders-row--clickable]="!!resolveErpOrderNo(row)"
				(click)="onTableRowClick(row, $event)"
			></tr>
			<tr class="mat-row" *matNoDataRow>
				<td class="mat-cell text-center text-muted py-4" [attr.colspan]="displayedColumns.length">
					{{ loading ? '' : 'No open B2B orders.' }}
				</td>
			</tr>
		</table>
		<mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
	</div>

	<!-- ── Order Export Activity ── -->
	<hr class="my-4">
	<div class="d-flex align-items-center mb-2" style="gap:8px">
		<strong class="small">Order Export Activity</strong>
	</div>

	<div class="d-flex align-items-center mb-3 flex-wrap" style="gap:8px">
		<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:140px">
			<mat-label>Status</mat-label>
			<mat-select [(ngModel)]="activityFilterStatus" (selectionChange)="loadActivity()">
				<mat-option value="">All</mat-option>
				<mat-option value="success">Success</mat-option>
				<mat-option value="error">Error</mat-option>
				<mat-option value="warning">Warning</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:160px">
			<mat-label>From</mat-label>
			<input matInput type="date" [(ngModel)]="activityFilterFromDate" (change)="loadActivity()">
		</mat-form-field>
		<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:160px">
			<mat-label>To</mat-label>
			<input matInput type="date" [(ngModel)]="activityFilterToDate" (change)="loadActivity()">
		</mat-form-field>
		<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:180px">
			<mat-label>Order #</mat-label>
			<input matInput [(ngModel)]="activityFilterPo" (keyup.enter)="loadActivity()" placeholder="Optional">
		</mat-form-field>
		<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:110px">
			<mat-label>Limit</mat-label>
			<mat-select [(ngModel)]="activityLimit" (selectionChange)="loadActivity()">
				<mat-option [value]="50">50</mat-option>
				<mat-option [value]="100">100</mat-option>
				<mat-option [value]="250">250</mat-option>
				<mat-option [value]="500">500</mat-option>
			</mat-select>
		</mat-form-field>
		<button mat-stroked-button (click)="loadActivity()" [disabled]="activityLoading">
			<mat-spinner *ngIf="activityLoading" diameter="18"></mat-spinner>
			<mat-icon *ngIf="!activityLoading">refresh</mat-icon>
			Refresh
		</button>
		<button mat-stroked-button (click)="resetActivityFilters()" matTooltip="Reset to last 30 days, errors only">
			<mat-icon>clear</mat-icon>
			Reset
		</button>
		<span class="text-muted small ml-auto" *ngIf="activityTotal > 0">
			Showing {{ activityRows.length }} of {{ activityTotal }} total
		</span>
	</div>

	<div *ngIf="activityError" class="alert alert-warning py-2 small">{{ activityError }}</div>
	<div *ngIf="activityLoading && activityRows.length === 0" class="text-muted small">Loading…</div>
	<div *ngIf="!activityLoading && activityRows.length === 0 && !activityError" class="alert alert-success py-2 small">
		No order export activity matches these filters.
	</div>

	<table *ngIf="activityRows.length > 0" class="table table-sm table-hover">
		<thead>
			<tr>
				<th>When</th>
				<th>Status</th>
				<th>Order#</th>
				<th>Message</th>
				<th class="text-nowrap"></th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let e of activityRows">
				<td class="text-nowrap text-muted small">{{ e.created_at | date:'M/d/yy, h:mm a' }}</td>
				<td class="text-nowrap">
					<span class="badge" [ngClass]="{
						'badge-success': e.status === 'success',
						'badge-danger': e.status === 'error',
						'badge-warning': e.status === 'warning'
					}">{{ e.status }}</span>
				</td>
				<td class="font-weight-bold small">{{ e.orderno || '—' }}</td>
				<td class="small" [ngClass]="{'text-danger': e.status === 'error'}" style="max-width:38rem;word-break:break-word;">{{ e.message }}</td>
				<td class="text-nowrap">
					<button mat-icon-button (click)="openActivityAttemptRaw(e)" matTooltip="View raw">
						<mat-icon>code</mat-icon>
					</button>
				</td>
			</tr>
		</tbody>
	</table>
</div>
